/**
* Created by Abner Sui on 10/16/2019
* -------------------------------------
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityFieldComponent } from './entity-field.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { DateFieldComponent } from './date-field.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { SingleTextDropdownFieldComponent } from './single-text-dropdown-field.component';
import { TempOtherComponent } from './temp-other.component';
import { FileUploadModule } from '../../file-upload/file-upload.module';
import { FileInfoModule } from '../file-info/file-info.module';
import { FileFieldComponent } from './file-field.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TextFieldComponent } from './text-field.component';
import { SingleEntityDropdownFieldComponent } from './single-entity-dropdown-field.component';
import { NumberFieldComponent } from './number-field.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NumberConfigComponent } from './number-config.component';
import { TextConfigComponent } from './text-config.component';
import { SingleEntityDropdownConfigComponent } from './single-entity-dropdown-config.component';
import { SingleTextDropdownConfigComponent } from './single-text-dropdown-config.component';
import { FileConfigComponent } from './file-config.component';
import { FieldConfigBaseComponent } from './field-config-base.component';
import { DateConfigComponent } from './date-config.component';
import { TextAreaConfigComponent } from './text-area-config.component';
import { TextAreaFieldComponent } from './text-area-field.component';
import { RichEditorFieldComponent } from './rich-editor-field.component';
import { RichEditorConfigComponent } from './rich-editor-config.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { EntityDropdownConfigComponent } from './entity-dropdown-config.component';
import { CheckListConfigComponent } from './check-list-config/check-list-config.component';
import { CheckListFieldComponent } from './check-list-field/check-list-field.component';
import { SingleUserDropdownConfigComponent } from './single-user-dropdown-config/single-user-dropdown-config.component';
import { SingleUserDropdownFieldComponent } from './single-user-dropdown-field/single-user-dropdown-field.component';

@NgModule({
    imports: [
        CommonModule,
        DropDownsModule,
        DateInputsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        WidgetsModule,
        FileUploadModule,
        FileInfoModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
    ],
    declarations: [
        EntityFieldComponent,
        DateFieldComponent,
        DateConfigComponent,
        SingleTextDropdownFieldComponent,
        TempOtherComponent,
        FileFieldComponent,
        TextFieldComponent,
        SingleEntityDropdownFieldComponent,
        NumberFieldComponent,
        NumberConfigComponent,
        TextConfigComponent,
        SingleEntityDropdownConfigComponent,
        SingleTextDropdownConfigComponent,
        FileConfigComponent,
        FieldConfigBaseComponent,
        TextAreaConfigComponent,
        TextAreaFieldComponent,
        RichEditorConfigComponent,
        RichEditorFieldComponent,
        EntityDropdownConfigComponent,
        CheckListConfigComponent,
        CheckListFieldComponent,
        SingleUserDropdownConfigComponent,
        SingleUserDropdownFieldComponent
    ],
    exports: [
        EntityFieldComponent,
        DateFieldComponent,
        DateConfigComponent,
        SingleTextDropdownFieldComponent,
        TempOtherComponent,
        FileFieldComponent,
        TextFieldComponent,
        SingleEntityDropdownFieldComponent,
        NumberFieldComponent,
        NumberConfigComponent,
        TextConfigComponent,
        SingleEntityDropdownConfigComponent,
        SingleTextDropdownConfigComponent,
        FileConfigComponent,
        TextAreaFieldComponent,
        TextAreaConfigComponent,
        RichEditorConfigComponent,
        RichEditorFieldComponent,
        EntityDropdownConfigComponent,
        CheckListConfigComponent,
        CheckListFieldComponent,
        SingleUserDropdownConfigComponent,
        SingleUserDropdownFieldComponent
    ],
    providers: []
})
export class FieldModule { }
